
import React from 'react';
import { Link } from 'react-router-dom';
import ReleaseCard from '@/components/releases/ReleaseCard';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Release } from '@/types';

interface ReleasesListProps {
  releases: Release[];
  showAddButton?: boolean;
}

const ReleasesList: React.FC<ReleasesListProps> = ({ releases, showAddButton = true }) => {
  return (
    <div>
      {showAddButton && (
        <div className="flex justify-end mb-6">
          <Button asChild className="gap-2">
            <Link to="/releases/new">
              <Plus className="h-4 w-4" />
              <span>Create New Release</span>
            </Link>
          </Button>
        </div>
      )}
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {releases.map(release => (
          <ReleaseCard 
            key={release.id} 
            id={release.id}
            title={release.title}
            coverArt={release.coverArt}
            releaseDate={release.releaseDate.toLocaleDateString()}
            streams={release.streams}
            status={release.status}
            platforms={release.platforms}
          />
        ))}
      </div>
    </div>
  );
};

export default ReleasesList;
